<template>
  <section v-if="message">
    <b-overlay :show="loading" rounded="sm">

      <b-form-textarea
        class="mt-2 p-2 textarea"
        id="messageContent"
        ref="messageContent"
        :placeholder="$t('RESPONSE')"
        input-id="message"
        v-model="content"
        autocomplete="off"
        rows="15"
        :state="content.length <= 20000"
        max-rows="15"
      ></b-form-textarea>
      <div class="error-text" v-if="content.length > 20000">
        {{ $t("ERROR.TOO_MANY_CHARACTERS") }}
      </div>
      <div class="text-right">
        <small class="pull-right">{{ content.length }}/20000</small>
      </div>

      <div class="mt-2">
        <FileSelect :max-size="GetMaxTotalBytesAllowedToSendSefosMessage" v-model="files" @added="updateAttachmentList">
          <b-button size="sm" class="no-border" variant="secondary">
            <i class="fal fa-plus"></i> {{ $t("ADD_FILES") }} ({{
              files.length
            }})
          </b-button>
        </FileSelect>
      </div>
      <div class="mt-2" v-if="files.length != 0"  :key="'attachments_' + files.length">
      <div :class="filesClass">
        <span
          v-for="(item, index) in files" :key="index" class="ms-fontSize-12"
        >
          <Attachment
            @removeFile="removeFile"
            :item="item"
            :index="index"
          ></Attachment>
        </span>
      </div>
      </div>
      <div class="error-text" v-if="!ValidateFileSize(currentFilesize)">
        {{ $t("ERROR.LARGE_FILES") }} {{ this.GetMaxTotalBytesAllowedToSendSefosMessage+"MB" }}
      </div>

      <hr class="p-0 m-0 mt-2 mb-2" />

      <b-button @click="closeReply">{{ $t("BACK") }}</b-button>
      
      <b-button
        :disabled="disabledSendMessage"
        @click="sendResponse"
        variant="primary"
        class="btn-fill"
        >{{ $t("RESPOND") }}</b-button
      >
    </b-overlay>
  </section>
</template>
<script>
import * as blobUtil from "blob-util";
import FileSelect from "@/components/Compose/FileSelect";
import Attachment from "@/components/Compose/Attachment";
export default {
  props: ["message", "link_uuid", "link_token"],
  components: {
    FileSelect,
    Attachment,
  },
  data() {
    return {
      responded: false,
      files: [],
      attachments: [],
      loading: false,
      content: "",
      attachmentIndex: 0
    };
  },
  methods: {
    getEmails(recipients) {
      let emails = "";
      for (let ix = 0; ix < recipients.length; ix++) {
        let item = this.message.recipients[ix];
        if (item.email != this.currentEmail) {
          if (item.type == "SEFOS" || item.type == "LINK") {
            if (emails == "") {
              emails = item.email;
            } else {
              emails = ", " + item.email;
            }
          }
        }
      }
      return emails;
    },
    buildReplyContent() {
      let sent = this.FormatDateTime(this.message.created_date);
      let content =
        "From: " +
        this.message.creator.name +
        " - " +
        this.message.creator.email;
      content = content + "\nSent: " + sent;
      content = content + "\nSubject: " + this.message.subject;
      content = content + "\n\n" + this.message.body;
      return content;
    },
    closeReply() {
      this.$emit("closeReply");
    },
    updateAttachmentList(){
      this.attachmentIndex++;
    },
    removeFile(index) {
      this.files.splice(index, 1);
      this.updateAttachmentList();
    },
    async getFileContent(file) {
      return new Promise((resolve) => {
        blobUtil
          .blobToBase64String(file)
          .then(function (base64String) {
            resolve(base64String);
          })
          .catch(function () {
            resolve(null);
          });
      });
    },
    async checkFiles() {
      this.attachments = [];
      for (let ix = 0; ix < this.files.length; ix++) {
        let base64Content = await this.getFileContent(this.files[ix]);
        if (base64Content == null) {
          this.$noty.error(self.$t("ERROR.EXCEPTION"));
          return false;
        } else {
          this.attachments.push({
            name: this.files[ix].name,
            type: this.files[ix].type,
            content: base64Content,
          });
        }
      }
      return true;
    },
    async sendResponse() {
      let self = this;
      self.loading = true;
      let iteratedFiles = await this.checkFiles();
      if (iteratedFiles == false) {
        return false;
      }
      let payload = {
        attachments: this.attachments,
        body: this.content,
        link_uuid: this.link_uuid,
      };
      this.$http
        .post(this.user.hostname + "/message/link/response", payload)
        .then(function (response) {
          self.loading = false;
          self.$emit("responded", response.data.message_uuid);
          self.responded = true;
        })
        .catch(function (error) {
          self.loading = false;
          //console.log(error);
          if (error.response.data != undefined) {
            self.$noty.error(self.$t(error.response.data));
          } else {
            self.$noty.error(self.$t("ERROR.COULD_NOT_SEND"));
          }
        });
    },
    ValidateFileSize(bytes)
    { 
      return bytes < (this.GetMaxTotalBytesAllowedToSendSefosMessage*1024*1024);
    },
    MoveCursorTop()
    {
      setTimeout(() => {
        let input = document.getElementById("messageContent");
        if(input != null)
        {
          input.setSelectionRange(0, 0);
        }
        input.focus();
      }, 200); 
    }
  },
  computed: {
    currentFilesize() {
      let filesize = 0;
      for (let ix = 0; ix < this.files.length; ix++) {
        filesize += this.files[ix].size;
      }
      return filesize;
    },
    filesClass() {
      if(this.ValidateFileSize(this.currentFilesize))
      {
         return ["is-valid"];
      } else {
        return ["is-invalid"];
      }
    },
    disabledSendMessage() {
      if(!this.ValidateFileSize(this.currentFilesize))
      {
        return true;
      }
      if (this.content.length > 20000) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.content =
      "\n\n---------------------------------------------------------\n" +
      this.buildReplyContent();      
    this.MoveCursorTop();
  },
};
</script>
<style lang="css"></style>
